/* eslint-disable import/prefer-default-export */
import { ReturnsProduct } from '@api/returns/types'
import Translations from '@helpers/translations'
import { returnsClickEvent } from '@components/returns/helpers'
import { Button } from '@components/ui/Button'
import {
  Values,
  ReasonListItem,
  ReasonListItemField
} from '@components/returns/types'
import AdditionalReasonField from './AdditionalReasonField'
import ButtonsWrapper from '../ButtonsWrapper'
import FormWrapper from '../FormWrapper'
import { PartialState, ValuesState } from '../../index'
import styles from '../../shared/styles.module.scss'

type ReasonStepProps = {
  selectedProduct: ReturnsProduct
  values: Values
  reasonList: ReasonListItem[]
  setSelection: (selection: PartialState<ValuesState>) => void
  onUpdate: (step: string | undefined) => void
  isLastStep: boolean
}

export function AdditionalFieldsStep({
  selectedProduct,
  values,
  reasonList,
  setSelection,
  onUpdate,
  isLastStep
}: ReasonStepProps) {
  const selectedReason = values.reason
  const buttonText = isLastStep
    ? Translations.localise('pages.returns.done')
    : 'Next'

  const additionalReasonFields: ReasonListItemField[] | undefined =
    reasonList.find(reason => reason.value === selectedReason)?.fields

  const handleUpdate = (step: string) => {
    returnsClickEvent({
      label: buttonText
    })
    if (step === 'prev') {
      setSelection({ sizes: { ...selectedProduct.sizes, available: true } })
    }
    onUpdate(step)
  }

  const handleOnAdditionalReasonSelection = (selection: string[]) => {
    setSelection({
      reason_detail: selection
    })
  }

  return (
    <>
      <FormWrapper title="Please let us know what isn't right">
        {additionalReasonFields?.map(field => (
          <AdditionalReasonField
            key={field.label}
            field={field}
            values={values}
            handleOnAdditionalReasonSelection={
              handleOnAdditionalReasonSelection
            }
          />
        ))}
      </FormWrapper>
      <ButtonsWrapper onUpdate={handleUpdate}>
        <Button
          disabled={!selectedReason}
          classes={styles.returnsForm__button}
          variant="primary"
          fullWidth="always"
          onClick={() => handleUpdate('next')}
        >
          {buttonText}
        </Button>
      </ButtonsWrapper>
    </>
  )
}
